const searchDrawer = () => {
    const selectors = {
        searchDrawerToggle: '[aria-controls="search-drawer"]',
        searchDrawerInput: 'search-drawer input[type="search"]',
    };
    const searchDrawerToggles = document.querySelectorAll(selectors.searchDrawerToggle);
    searchDrawerToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            /*
            This is not an ideal solution!
            iOS appears to be sensitive to applying :focus to elements that are not visible.
            This includes display: none, visibility: hidden etc
            */
            const fakeInput = document.createElement('input');
            fakeInput.setAttribute('type', 'search');
            fakeInput.style.position = 'absolute';
            fakeInput.style.opacity = 0;
            fakeInput.style.height = 0;
            fakeInput.style.fontSize = '16px'; // disable auto zoom
            document.body.prepend(fakeInput);
            fakeInput.focus();
            setTimeout(() => {
                const searchInput = document.querySelector(selectors.searchDrawerInput);
                searchInput.focus();
                fakeInput.remove();
            }, 100);
        });
    });
};
export { searchDrawer };
